module.exports = __webpack_public_path__ + "img/digitalServices.fdad7ba2.svg";